import { RootState } from '../../app/state'
import { MsgBarDefinition } from './msgBarsState'

export const getMsgBars = (state: RootState): MsgBarDefinition[] =>
  state.msgBars.msgBars
